import type { NetworkClient } from '~/lib/bosca/networkclient'
import { Security } from '~/lib/bosca/security'
import { Content } from '~/lib/bosca/content'
import { Search } from '~/lib/bosca/search'
import { Profiles } from '~/lib/bosca/profiles'

export class BoscaClient<T extends NetworkClient> {
    readonly security: Security<T>
    readonly content: Content<T>
    readonly search: Search<T>
    readonly profiles: Profiles<T>

    constructor(network: T) {
        this.profiles = new Profiles<T>(network)
        this.security = new Security<T>(network)
        this.content = new Content<T>(network)
        this.search = new Search<T>(network)
    }
}
